import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import {
  ControlContainer,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { AppSettings } from 'pac-api';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { WizardService } from 'src/app/wizard/wizard.service';
import { DateValidator, now } from '../../helpers';

import { Gender } from '../../model/gender.enum';
import { Individual } from '../../model/individual';

const earliest = new Date(1901, 2, 3);
const latest = new Date(now);
latest.setFullYear(now.getFullYear() - 13);

@Component({
  selector: 'app-demographics',
  templateUrl: './demographics.component.html',
  styleUrls: ['./demographics.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class DemographicsComponent implements OnInit {

  @Input() individual: Individual;
  @Input() isSaving: boolean;
  @Input() existing: boolean;
  @Input() form: UntypedFormGroup;
  @Input() OnSave: EventEmitter<Individual>;

  group: UntypedFormGroup;
  gender = Gender;

  public ind_mblex_date_extHasError: Observable<boolean>;
  public ind_dobHasError: Observable<boolean>;

  constructor(private wizard: WizardService, public settings: AppSettings) { }

  ngOnInit() {
    const _ind_mblex_date_ext = this.individual.ind_mblex_date_ext ? formatDate(this.individual.ind_mblex_date_ext, 'MM/dd/yyyy', 'en-US') : null;
    const ind_mblex_date_ext = new UntypedFormControl(_ind_mblex_date_ext, [ DateValidator(earliest, new Date(2099, 12, 31)) ]);
    const ind_dob = new UntypedFormControl(this.individual.ind_dob, [ Validators.required, DateValidator(earliest, latest) ]);
    const ind_gender = new UntypedFormControl(this.individual.ind_gender, [ Validators.required ]);

    this.group = new UntypedFormGroup({ ind_mblex_date_ext, ind_dob, ind_gender });
    this.form.addControl('demographics', this.group);

    this.OnSave.subscribe(individual => this.Save(individual));

    this.ind_mblex_date_extHasError = ind_mblex_date_ext.statusChanges.pipe(
      map(status => status === 'INVALID' && (ind_mblex_date_ext.dirty || ind_mblex_date_ext.touched)),
      shareReplay(1),
    );

    this.ind_dobHasError = ind_dob.statusChanges.pipe(
      map(status => status === 'INVALID' && (ind_dob.dirty || ind_dob.touched)),
      shareReplay(1),
    );
  }

  Save(individual: Individual) {
    const values = this.group.value;

    if (values.ind_mblex_date_ext) {
      values.ind_mblex_date_ext = new Date(values.ind_mblex_date_ext);
    } else {
      values.ind_mblex_date_ext = null;
    }

    if (values.ind_dob) {
      values.ind_dob = new Date(values.ind_dob);
    } else {
      values.ind_dob = null;
    }

    if (values.ind_gender === Gender.Other) {
      values.ind_gender = null;
    }

    Object.assign(individual, values);
  }
}
